export const PLUSPOINT_INTEGRATION = 4;

export const GOOGLE_OAUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${window.location.origin}/account-settings/integrations&access_type=offline&response_type=code&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fbusiness.manage%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fbusinesscommunications%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&include_granted_scopes=true&state=pass-through%20value&flowName=GeneralOAuthFlow&prompt=consent`;
export const GOOGLE_ONBOARDING_OAUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${window.location.origin}/onboarding&access_type=offline&response_type=code&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fbusiness.manage%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fbusinesscommunications%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&include_granted_scopes=true&state=pass-through%20value&flowName=GeneralOAuthFlow&prompt=consent`;
export const ZAPIER_URL = 'https://zapier.com/apps/pluspoint/integrations';
export const GOOGLE_OAUTH_SIGN_IN_URL = `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${window.location.origin}/login&access_type=offline&response_type=code&scope=openid%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&include_granted_scopes=true&state=pass-through%20value&flowName=GeneralOAuthFlow`;
export const GOOGLE_OAUTH_SIGN_UP_URL = `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${window.location.origin}/signup&access_type=offline&response_type=code&scope=openid%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fbusiness.manage%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fbusinesscommunications&include_granted_scopes=true&state=pass-through%20value&flowName=GeneralOAuthFlow&prompt=consent`;

export const ProfileType = {
    1: 'Yelp',
    2: 'Facebook',
    3: 'Google',
    8: 'Trustpilot',
    9: 'TripAdvisor',
    12: 'Instagram',
    14: 'TheFork',
    15: 'Deliveroo',
    16: 'Booking.com',
    24: 'Youtube',
    25: 'X',
    26: 'LinkedIn',
    27: 'Pinterest',
    28: 'Tiktok',
    29: 'Hotels.com',
    30: 'Expedia',
    32: 'Healthgrades',
    33: 'Zocdoc',
    34: 'RateMDs',
    // INFO: Profiles created via Location integrations
    10: 'Google',
    20: 'Facebook',
    19: 'CoverManager',
    17: 'iFood',
    18: 'VTEX',
    31: 'Apple',
    // INFO: Profiles created via Packs
    36: 'Foursquare',
    37: 'AmazonAlexa',
    38: 'Waze',
    39: 'Navmii',
    40: 'TomTom',
    41: 'Uber',
    42: 'HERE',
    43: 'NetworkPack',
};

export const ProfileName = {
    Yelp: 1,
    Facebook: 2,
    Google: 3,
    Trustpilot: 8,
    TripAdvisor: 9,
    Instagram: 12,
    TheFork: 14,
    Deliveroo: 15,
    'Booking.com': 16,
    YouTube: 24,
    X: 25,
    LinkedIn: 26,
    Pinterest: 27,
    Tiktok: 28,
    'Hotels.com': 29,
    Expedia: 30,
    Healthgrades: 32,
    Zocdoc: 33,
    RateMDs: 34,
    // INFO: Profiles created via Location integrations
    GoogleOfficial: 10,
    FacebookOfficial: 20,
    CoverManager: 19,
    iFood: 17,
    VTEX: 18,
    Apple: 31,
    // INFO: Profiles created via Packs
    Foursquare: 36,
    AmazonAlexa: 37,
    Waze: 38,
    Navmii: 39,
    TomTom: 40,
    Uber: 41,
    HERE: 42,
    NetworkPack: 43,
};

// INFO: Dict for Profiles section in Location settings
export const LocationProfilesDictionary = [
    { name: 'Google', type: ProfileName.Google },
    { name: 'Facebook', type: ProfileName.Facebook },
    { name: 'Trustpilot', type: ProfileName.Trustpilot },
    { name: 'Yelp', type: ProfileName.Yelp },
    { name: 'TripAdvisor', type: ProfileName.TripAdvisor },
    { name: 'Instagram', type: ProfileName.Instagram },
    { name: 'TheFork', type: ProfileName.TheFork },
    { name: 'Deliveroo', type: ProfileName.Deliveroo },
    { name: 'Booking.com', type: ProfileName['Booking.com'] },
    { name: 'YouTube', type: ProfileName.YouTube },
    { name: 'X', type: ProfileName.X },
    { name: 'LinkedIn', type: ProfileName.LinkedIn },
    { name: 'Pinterest', type: ProfileName.Pinterest },
    { name: 'Tiktok', type: ProfileName.Tiktok },
    { name: 'Hotels.com', type: ProfileName['Hotels.com'] },
    { name: 'Expedia', type: ProfileName.Expedia },
    { name: 'Healthgrades', type: ProfileName.Healthgrades },
    { name: 'Zocdoc', type: ProfileName.Zocdoc },
    { name: 'RateMDs', type: ProfileName.RateMDs },
    // INFO: Profiles created via Packs
    { name: 'Foursquare', type: ProfileName.Foursquare },
    { name: 'AmazonAlexa', type: ProfileName.AmazonAlexa },
    { name: 'Waze', type: ProfileName.Waze },
    { name: 'Navmii', type: ProfileName.Navmii },
    { name: 'TomTom', type: ProfileName.TomTom },
    { name: 'Uber', type: ProfileName.Uber },
    { name: 'HERE', type: ProfileName.HERE },
    { name: 'NetworkPack', type: ProfileName.NetworkPack },
];

export const LocationIntegrationName = {
    Google: 0,
    Facebook: 1,
    CoverManager: 2,
    Apple: 3,
    iFood: 4,
    VTEX: 5,
    SearchPack: 6,
    NavigationPack: 7,
    NetworkPack: 8,
};

export const LocationIntegrationType = {
    0: 'Google',
    1: 'Facebook',
    2: 'CoverManager',
    3: 'Apple',
    4: 'iFood',
    5: 'VTEX',
    6: 'SearchPack',
    7: 'NavigationPack',
    8: 'NetworkPack',
};

export const AccIntegrationName = {
    Zapier: 11,
    Google: 10,
    Facebook: 20,
    WhatsApp: 35,
    Apple: 31,
    'API integration': 0,
    iFood: 17,
    CoverManager: 19,
    VTEX: 18,
    Salesforce: 1,
    Xero: 2,
    Pipedrive: 3,
    Hubspot: 4,
    QuickBooks: 5,
};

// INFO: Dict for Account Integrations page
export const AccountIntegrationsDictionary = [
    { id: AccIntegrationName.Zapier, name: 'Zapier' },
    { id: AccIntegrationName.Google, name: 'Google' },
    { id: AccIntegrationName.Facebook, name: 'Facebook' },
    { id: AccIntegrationName.WhatsApp, name: 'WhatsApp' },
    { id: AccIntegrationName.Apple, name: 'Apple' },
    { id: AccIntegrationName['API integration'], name: 'API integration' },
    { id: AccIntegrationName.iFood, name: 'iFood' },
    { id: AccIntegrationName.CoverManager, name: 'CoverManager' },
    { id: AccIntegrationName.VTEX, name: 'VTEX' },
    { id: AccIntegrationName.Salesforce, name: 'Salesforce' },
    { id: AccIntegrationName.Xero, name: 'Xero' },
    { id: AccIntegrationName.Pipedrive, name: 'Pipedrive' },
    { id: AccIntegrationName.Hubspot, name: 'Hubspot' },
    { id: AccIntegrationName.QuickBooks, name: 'QuickBooks' },
];

// INFO: Integrations and Profiles used in Manage reviews, Analytics reviews, Widgets
export const FiltersIntegrationName = {
    Yelp: 1,
    Facebook: 2,
    Google: 3,
    Trustpilot: 8,
    TripAdvisor: 9,
    TheFork: 14,
    Deliveroo: 15,
    'Booking.com': 16,
    iFood: 17,
    'Hotels.com': 29,
    Expedia: 30,
    Healthgrades: 32,
    Zocdoc: 33,
    RateMDs: 34,
};

export const FiltersIntegrationType = {
    1: 'Yelp',
    2: 'Facebook',
    3: 'Google',
    8: 'Trustpilot',
    9: 'TripAdvisor',
    14: 'TheFork',
    15: 'Deliveroo',
    16: 'Booking.com',
    17: 'iFood',
    29: 'Hotels.com',
    30: 'Expedia',
    32: 'Healthgrades',
    33: 'Zocdoc',
    34: 'RateMDs',
};
